import { render } from "./SurveyCreate.vue?vue&type=template&id=58e3cf21&scoped=true"
import script from "./SurveyCreate.vue?vue&type=script&lang=js"
export * from "./SurveyCreate.vue?vue&type=script&lang=js"

import "./SurveyCreate.vue?vue&type=style&index=0&id=58e3cf21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e3cf21"]])

export default __exports__